<template>
  <div>
    <header class="memberHeader nav-down cf" v-show ="$store.getters.myModel">
      <div class="wrapper">
        <div class="topSec">
          <router-link to="/index" class="backToHome">首頁</router-link>
          <strong class="logo">
            <router-link to="/index">
              <img src="@/assets/images/logo.png" alt="一刻鯨選">
            </router-link>
          </strong>

          <div class="tools">
            <!--會員已登入-->
            <div class="globalMember">
              <button >
                <span class="photo"><img :src="userInfo.avatar"/></span>
              </button>
            </div>
            <!--會員已登入 end-->
          </div>
        </div>
      </div>
    </header>

    <header class="bodyHeader nav-down cf" v-show ="($store.getters.myModel && windowWidth > 768) || !$store.getters.myModel">

      <div class="wrapper">
        <div class="topSec">
            <a href="#0"  class="nav_trigger">Menu<span></span><span></span><span></span><span></span></a>
            <!-- <a href="index.html" class="backToHome">首頁</a> -->
            <strong class="logo">
              <router-link to="/index">
                <img src="@/assets/images/logo.png"  alt="一刻鯨選">
              </router-link>
            </strong>

            <div class="tools">
              <div class="search_group">
                <button class="search_icon" @click.stop="toggleSearchBar">
                  <img src="@/assets/images/icon_search_color.svg" alt="search_icon">
                </button>
                <div class="search_bar" :class="{ 'open': openSearch === true }" @click.stop="stopPoup($event)">
                  <img src="@/assets/images/icon_search.svg" class="search_bar_icon" alt="search_blackicon">
                  <input
                    ref="searchInput"
                    v-model="keyWord"
                    v-on:keydown.13="search()"
                    class="search_input"
                    placeholder="輸入關鍵字"
                    type="search"
                    autocomplete="off"
                    name="search">
                  <button
                    class="btn btn-primary search_btn"
                    @click="search()">
                    搜尋
                  </button>
                  <i @click="search()" class="search_btn_icon ">
                    <img src="@/assets/images/icon_search_color.svg" alt="search_clearicon">
                  </i>
                  <i @click="keyWord = ''" class="search_clear_icon">
                    <img src="@/assets/images/icon_searchclear.svg" alt="search_clearicon">
                  </i>
                  <a class='overlay' @click="closeSearch"></a>
                </div>

              </div>

              <div class="globalSearch">

                <div id="sb-search"  class="sb-search">
                  <!-- <button id="searchtrigger" @click="toggleSearchBar">Search</button> -->
                  <div id="search" >
                    <!-- :class="{ 'open': openSearch === true }" -->
                    <div class="search-group">
                      <input
                      type="text"
                      class="search-input hidden-password"
                      id="search-input"
                      value=""
                      name="search"
                      placeholder="輸入關鍵字"
                      />
                      <!-- v-model="keyWord"
                       ref="searchInput"
                       v-on:keydown.13="search()" -->
                      <!-- <button type="submit" class="btn btn-primary search-btn" @click="search()">搜尋</button>
                      <i id="clear" @click="keyWord = ''">&times;</i> -->
                    </div>
                    <!-- <a class='overlay' @click="closeSearch"></a> -->
                  </div>
                </div>
              </div>

              <!--會員功能規劃中，之後會再改-->
              <div class="globalMember">
                <a class="unlogin" href="javascript:;" v-show="!isAuthenticated">登入</a>
                <button @click="pushToProfile" v-show="isAuthenticated">
                  <span class="photo"><img :src="userInfo.avatar"/></span>
                  <span class="name">{{userInfo.nickname}}</span>
                </button>
                <div class="memList" v-show="isAuthenticated">
                  <nav v-show="isAuthenticated">
                    <ul class="cf">
                      <router-link @click.native="changeMyIndicator(index)" :key="index" v-for="(navigator, index) in myNavigators" :class="[{'current':navigator.isSelected}, navigator.class]" tag="li" :to="navigator.to"><a>{{navigator.title}}</a></router-link>
                    </ul>
                  </nav>
                </div>
              </div>
              <!--會員功能規劃中，之後會再改 end-->
            </div>
            <ul class="socialMedia">
              <li class="fb"><a href="https://www.facebook.com/jinfmnet/" target="_blank">Facebook粉絲團</a></li>
              <li class="yt"><a href="https://www.youtube.com/channel/UChsuz3ui48kTwvuY059i2lA?disable_polymer=true" target="_blank">YouTube頻道</a></li>
            </ul>
        </div>

        <nav class="mainNav cf">
          <ul class="cf">
            <!--因為配合行動版要顯示的項目不一樣，每個項目li都有自己的class name-->
            <!-- <li ></li> -->
            <router-link @click.native="changeIndicator(index)" :key="index" v-for="(navigator, index) in navigators" :class="[{'current':navigator.title == $store.state.breadcrumb[1].name}, navigator.class]" tag="li" :to="navigator.to"><a>{{navigator.title}}</a></router-link>
          </ul>
        </nav>

        <!--行動版navigation-->

        <nav class="mainNav_mobile cf">
          <div class="container">
            <ul class="cf">
              <li >
                <router-link to="/news/list"  @click.native="changeIndicator()"><a href="/news/list" @click="close()">最新消息</a></router-link>
              </li>
              <li >
                <router-link to="/story" @click.native="changeIndicator()"><a href="/story" @click="close()">品牌故事</a></router-link>
              </li>
              <!-- <li><a href="https://jinfm.net/blog/">部落格</a></li> -->
              <li>
                <router-link to="/help" @click.native="changeIndicator()"><a href="/help" @click="close()">常見問題</a></router-link>
              </li>
              <li>
                <router-link to="/contact" @click.native="changeIndicator()"><a href="/contact" @click="close()">聯絡我們</a></router-link>
              </li>
              <li>
                <router-link to="/terms" @click.native="changeIndicator()"><a href="/terms" @click="close()">服務條款</a></router-link>
              </li>
              <li>
                <a href="https://mobile.udn.com/docs/m_privacy.shtml" target="_blank">隱私權聲明</a>
              </li>
            </ul>
            <ul class="socialMedia">
              <li class="fb"><a href="https://www.facebook.com/jinfmnet/" target="_blank">Facebook粉絲團</a></li>
              <li class="yt"><a href="https://www.youtube.com/channel/UChsuz3ui48kTwvuY059i2lA?disable_polymer=true" target="_blank">YouTube頻道</a></li>
            </ul>
            <!-- <ul class="language">
                <li class="current"><a href="#">繁體中文</a></li>
                <li><a href="#">簡体中文</a></li>
            </ul> -->
          </div>
        </nav>

        <div class="promote_popup" v-show="isIOS">
          <div class="wrap">
            <figure>
              <router-link to="/member/coupon" ><img @click="closePoP()" src="@/assets/images/banner/popbanner_tibe.jpg"> </router-link>
            </figure>
          </div>
        </div>

          <!--行動版navigation end-->
      </div>

      <div class="login" >
        <div class="loginWrap">
          <div class="mode" >
            <div class="wrap">
              <strong class="logo_jin">
                <img src="@/assets/images/logo.png" alt="一刻鯨選">
              </strong>
              <p class="topInfo">您可以選擇任何一種方式登入，<br>無須註冊即可快速登入使用一刻鯨選服務</p>

              <ul>
                <li class="login_udn"><button  @click="clearDatas"><span>udn會員登入</span></button></li>
                <li class="login_mobile"><button  @click="clearDatas"><span>手機號碼登入</span></button></li>
                <li class="login_facebook">
                    <!-- <a href="#">使用Facebook登入</a> -->
                    <button @click="socialMediaLoginTest('fb')"><span>Facebook登入</span></button>
                </li>
                <li class="login_google">
                    <!-- <a href="#">使用Google登入</a> -->
                    <button @click="socialMediaLoginTest('google')"><span>Google登入</span></button>
                </li>
                <li class="login_apple">
                    <!-- <a href="#">使用Apple登入</a> -->
                    <button @click="socialMediaLoginTest('apple')"><span>Sign in with Apple</span></button>
                </li>
              </ul>
              <p class="btmInfo">選擇上述任一方式，<br>表示您已經閱讀並同意一刻鯨選的<a href="/terms" target="_blank">【服務條款】</a></p>
            </div>
          </div>
          <div id="login_udn" class="signForm udn" >
            <article>
              <div class="wrap">
                <figure><img src="@/assets/images/logo_udn_s.png" alt="udn logo"><p>udn會員登入</p></figure>

                <label for="usernameudn" :class="[{'error': !emailValid },'inp']"><!--如果輸入錯誤 新增class "error"-->
                  <input @blur="checkerEmail(udnAccount.email)" :disabled="validated == 1" type="text" id="usernameudn" v-model="udnAccount.email" placeholder=" ">
                  <span class="label">請輸入帳號</span>
                  <span class="border"></span>
                  <span class="errorText">電子信箱格式錯誤</span><!--輸入錯誤時出現-->
                </label>
                <label for="passwordudn" :class="[{'error': isUdnLoginError },'inp']">
                  <input  @keyup.enter="udnAccountValidation"  type="password" :disabled="validated == 1" v-model="udnAccount.pwd" id="passwordudn" placeholder=" ">
                  <span  class="label">請輸入密碼</span>
                  <span class="border"></span>
                  <span class="errorText">登入失敗</span><!--輸入錯誤時出現-->

                </label>
                <button v-promise-btn  type="submit"   @click="udnAccountValidation" class="btnStyle_2" id="submit_login_udn">
                  <span data-original-title="登入">登入</span>
                </button>

                <a class="backToMode" :disabled="validated == 1" href="javascript:;">其他方式登入</a>
              </div>

            </article>
          </div>
          <div id="login_mobile" class="signForm mobile">
            <article>
              <div class="wrap">

                <figure><img src="@/assets/images/logo_mobile.png" alt="mobile logo"><p>手機號碼登入</p></figure>

                <div class="phoneNumber cf">
                  <div class="code">
                    <span>國碼</span>
                    <div class="selectStyle_1">

                      <!-- <rain-auto-complete-input  class="selectStyle_1" :items="[ 'eee','eee2ee']"></rain-auto-complete-input>  -->
                      <select v-model="CountryCode" aria-hidden="true" class="selectStyle_1">
                        <option v-for="countryJson in countryJsons" :value="countryJson.code" :key="countryJson.id">
                        {{ countryJson.code }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ countryJson.name }}
                        </option>
                      </select>

                    </div>
                  </div>
                  <div class="number">
                    <label for="mobileNum" :class="[{'error': !phoneValid },'inp']">
                      <input   v-model="phoneNumber"  @blur="checkPhone(phoneNumber)"   aria-label="請輸入手機號碼" type="tel" id="mobileNum" placeholder=" ">
                      <span  class="label">請輸入機號碼</span>
                      <span class="border"></span>
                      <span class="errorText">手機號碼輸入錯誤</span><!--輸入錯誤時出現-->
                    </label>
                  </div>
                </div>

                <div id="sign-in-button"></div>

                <button v-if="isPhoneLoginSuccess == false" :disabled="countDownFlag"  @click="firebaseLoginWith('eee','phone')" class="btnStyle_2 color1light" id="getNewcode">
                  <rain-counter @time-end="countDownFlag=false,isPhoneLoginSuccess = false" :endTime='end' v-if="countDownFlag"></rain-counter>
                  <span data-original-title="取得驗證碼" v-else>取得驗證碼</span><!--倒數60秒顯示的字「60 秒後即可重新方送驗證碼」-->
                </button>

                <button v-else :disabled="countDownFlag"  @click="firebaseLoginWith('eee','phone')" class="btnStyle_2 color1light disable" id="getNewcode">
                  <rain-counter @time-end="countDownFlag=false,isPhoneLoginSuccess = false" :endTime='end' v-if="countDownFlag"></rain-counter>
                  <span data-original-title="取得驗證碼" v-else>取得驗證碼</span><!--倒數60秒顯示的字「60 秒後即可重新方送驗證碼」-->
                </button>
                                                            <p></p>
                <label for="Verification" :class="[{'error': isPhoneVerificationCodeError },'inp']">
                  <input  @keyup.enter="getUserDataInfoFromPhone"  type="tel" id="Verification"  v-model="validatedCode" placeholder=" ">
                  <span class="label">請輸入驗證碼</span>
                  <span class="border"></span>
                  <span class="infoText">取得驗證碼後，請在60秒內輸入驗證碼</span>
                  <span class="errorText">驗證碼輸入錯誤</span><!--輸入錯誤時出現-->
                </label>
                <button v-promise-btn @click="getUserDataInfoFromPhone" type="submit" class="btnStyle_2" id="submit_login_mobile">
                  <span  data-original-title="登入">登入</span>
                </button>
                <a class="backToMode" :disabled="validated == 1" href="javascript:;">其他方式登入</a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint eqeqeq: "off" */

import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
// import Cookies from 'js-cookie'

import AWS from 'aws-sdk/global'
import Lambda from 'aws-sdk/clients/lambda.js'
import KMS from 'aws-sdk/clients/kms.js'
// import Config from 'aws-sdk/clients/configservice'
import { getPersonalData } from '@/assets/js/api/api.js'
import rainCounter from '@/components/widget/rainCounter'
// import rainAutoCompleteInput from '@/components/widget/rainAutoCompleteInput'
import { emailChecker } from '@/assets/js/rainFunctions.js'
import seachImg from '@/assets/images/icon_search_color.svg'

firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGEING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
  measurementId: process.env.FIREBASE_MEASUREMENT_ID
})

AWS.config.region = 'ap-northeast-1' // 区域
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: 'ap-northeast-1:63985611-aadb-4d6f-b653-2c4cbdd5bb94'
})

export default {
  inject: ['reload'],
  components: {
    rainCounter
    // rainAutoCompleteInput
  },
  data () {
    return {
      app: '',
      imgSrc: '@/assets/images/logo.png',
      KeyId: 'arn:aws:kms:ap-northeast-1:580691962331:alias/ear-app-Encrypt',
      udnAccount: {
        email: '',
        pwd: '',
        type: 'udn'
      },
      end: new Date().getTime() + 60000,
      validated: 0,
      validatedCode: '', // phone validated code
      phoneNumber: '', // phone number,
      countryJsons: '',
      keyWord: '',
      CountryCode: '+886',
      countDownFlag: false,
      emailValid: true,
      phoneValid: true,
      smsValid: false,
      openSearch: false,
      isIOS: false,
      isUdnLoginError: false,
      isPhoneVerificationCodeError: false, // 手機驗證碼是否錯誤
      isPhoneLoginSuccess: false, // 判斷手機登入是否錯誤
      windowWidth: window.innerWidth,
      data: '',
      searchIcon: seachImg
    }
  },

  created () {
    this.countryJsons = require('@/assets/json/country_code.json')
    // console.log(process.env.FIREBASE_API_KEY);
    // localStorage.setItem("isIosMsgShow", "false");
    // var u = navigator.userAgent
    //  this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    // if(this.isIOS == true){
    //  this.isIOS = true;
    // if ( result ) {
    //     // the user clicked ok
    // } else {
    //     // the user clicked cancel or closed the confirm dialog.
    // }
    //  }
  },

  update () {
    this.getUser(` ${localStorage.getItem('credentialToken')}`)
  },

  mounted () {
    // 20191125新增 start
    // $(function () {
    // $('#search').append("<a class='overlay'></a>")

    // // eslint-disable-next-line no-unused-vars
    // const button = $('#searchtrigger')
    // const overlay = $('#search')
    // overlay.scrollableOverlay()

    // // eslint-disable-next-line no-unused-vars
    // const body = $('body')

    // $('#searchtrigger').on('click', function (event) {
    //   event.preventDefault()
    //   $('#search').addClass('open')
    //   overlay.trigger('show')
    //   $('#search > form > input[type="search"]').focus()
    // })

    // $('#search, #search button.close, #search .overlay').on('click keyup', function (event) {
    //   if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
    //     console.log('#search close');
    //     $('#search').removeClass('open')
    //     overlay.trigger('hide')
    //   }
    // })

    // $('#search').focusout(closeSearch)
    // function closeSearch (e) {
    //   if ($(window).width() > 768) {
    //     e.preventDefault()
    //     $(this).removeClass('open')
    //     overlay.trigger('hide')
    //   } else {
    //     return false
    //   }
    // }

    // $('#clear').click(
    //   function () {
    //     $('#search input[type="search"]').val('')
    //   })
    //  })

    // // eslint-disable-next-line no-unused-expressions
    // 'use strict'

    // (function ($) {
    //   var lastWindowScrollTop = 0
    //   var userAgent = navigator.userAgent
    //   var $body = $('body')
    //   var isIOS = /iPhone|iPad/.test(userAgent)
    //   var NO_SCROLL_CLASS = isIOS
    //     ? 'ios-noscroll'
    //     : 'non-ios-noscroll'

    //   function fixedBody () {
    //     if (isIOS) {
    //       lastWindowScrollTop = $(window).scrollTop()
    //       $body.addClass(NO_SCROLL_CLASS)
    //       $body.css('top', '-' + lastWindowScrollTop + 'px')
    //     } else {
    //       $body.addClass(NO_SCROLL_CLASS)
    //     }
    //   }

    //   function looseBody () {
    //     $body.removeClass(NO_SCROLL_CLASS)
    //     if (isIOS) {
    //       $body.css('top', '')
    //       window.scrollTo(0, lastWindowScrollTop)
    //     }
    //   }

    //   $.fn.scrollableOverlay = function () {
    //     this.on('show', fixedBody)
    //     this.on('hide', looseBody)
    //   }
    // })(jQuery)
    // 20191125新增 end
    // $(function(){
    //   $('.search-input').attr("readonly","readonly");
    //   $('.search-input').click(function(){
    //     $(this).removeAttr("readonly");
    //   });
    // });

    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
      document.querySelector('body').addEventListener('click', this.closeSearch)
    })

    // 宣傳 popup banner
    $('.promote_popup .wrap').prepend("<button class='closeBtn'><span>Close</span></button>")
    $('.promote_popup').append("<a class='overlay'></a>")

    $('.promote_popup .closeBtn, .promote_popup .overlay').click(function () {
      $('.promote_popup').fadeOut()
    })

    $('.mainNav_mobile').append("<a href='#0' class='nav_trigger'>Menu<span></span><span></span><span></span><span></span></a>")
    $('.nav_trigger').click(function () {
      $('.nav_trigger').toggleClass('open')
      $('.mainNav_mobile').fadeToggle('slow', 'linear')
      $('body, .bodyWrapper').toggleClass('overflowhidden')
    })

    $('.login .wrap').prepend("<button class='closeBtn'><span>Close</span></button>")
    $('.login').append("<a class='overlay'></a>")

    $('.login_udn button').click(function () {
      $('#login_udn').fadeIn(200).css('display', 'flex')
      return false
    })

    $('.login_mobile button').click(function () {
      $('#login_mobile').fadeIn(200).css('display', 'flex')
      return false
    })

    $('.backToMode').click(function () {
      $('.signForm').fadeOut()
      // $('.wrapper').removeClass('noScroll')
    })

    $('.closeBtn , .overlay').click(function () {
      $('.login').fadeOut()
      $('.signForm').fadeOut()
      $('body, .bodyWrapper').removeClass('overflowhidden')
    })

    // header「會員」功能nav
    $('.globalMember').hover(function () {
      $('.memList').stop().slideDown(300)
    }, function () {
      $('.memList').stop().slideUp(300)
    })
  },
  computed: {

    // mix the getters into computed with object spread operator
    ...mapGetters([
      'navigators',
      'userInfo',
      'myNavigators',
      'isAuthenticated'

    ])
  },
  methods: {

    closePoP () {
      $('.promote_popup').fadeOut()
    },
    close () {
      $('.nav_trigger').toggleClass('open')
      $('.mainNav_mobile').fadeToggle('slow', 'linear')
      $('body, .bodyWrapper').toggleClass('overflowhidden')
    },
    pushToProfile () {
      if (this.windowWidth < 768) {
        this.$router.push('/member/profile')
          .catch(err => { console.log(err) })
      }
    },
    search () {
      this.$router.push({
        path: `/search/?q=${this.keyWord}`
      })
        .catch(err => { console.log(err) })
      this.keyWord = ''
      this.closeSearch()
    },
    // 切換SearchBar，在420px以下關閉Scroll效果
    toggleSearchBar () {
      if (this.openSearch === false) {
        this.openSearch = true
        this.$refs.searchInput.focus()
        if (document.querySelector('body').clientWidth < 420) {
          this.stopScroll(true)
        }
      } else {
        this.closeSearch()
      }
    },
    // 關閉SearchBar，在420px以下移除Scroll鎖定
    closeSearch () {
      this.openSearch = false
      this.stopScroll(false)
    },
    // 切換Scroll效果
    stopScroll (val) {
      if (val) {
        this.$modalHelper.afterOpen()
      } else {
        this.$modalHelper.beforeClose()
      }
    },
    clearDatas () {
      this.udnAccount = {
        email: '',
        pwd: '',
        type: 'udn'
      }
      this.emailValid = true
      this.phoneValid = true
      this.isUdnLoginError = false
      this.isPhoneVerificationCodeError = false
      this.validated = 0
      this.phoneNumber = ''
      this.validatedCode = ''
    },
    checkerEmail (email) {
      // if(email.includes('@')){
      //   this.emailValid = true;
      // }
      // else{
      //   this.emailValid = false;
      // }
      this.emailValid = emailChecker(email)
    },
    checkPhone (phoneNumber) {
      if (phoneNumber.length <= 6) {
        this.phoneValid = false
      } else {
        this.phoneValid = true
      }
    },
    signOut () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('authLogout').then(() => {
            this.$router.push('/')
              .catch(err => { console.log(err) })
            this.$store.commit('savePath', '/index')
          })
          localStorage.removeItem('user-info')
          // $('#login_udn').fadeIn(200)

          // Sign-out successful.
        })
        .catch(function (error) {
          console.log(error)
          // An error happened.
        })
    },
    changeMyIndicator (index) {
      if (index == this.myNavigators.length - 1) {
        this.signOut()
        return
      }
      this.myNavigators.forEach(v => {
        v.isSelected = false
      })
      this.myNavigators[index].isSelected = true
    },
    changeIndicator (index) {
      if (index == 2) {
        location.reload()
      }

      this.navigators.forEach(v => {
        v.isSelected = false
      })
      this.navigators[index].isSelected = true
      //   if(index == 0){
      //      $('.global_qrcode').css('opacity', '1');
      //  }else{
      //   $('.global_qrcode').css('opacity', '0');

    //  }
    },
    kmsEncrypt (params) {
      // eslint-disable-next-line promise/param-names
      return new Promise((s, j) => {
        const kmsClient = new KMS() // kmsTool
        kmsClient.encrypt(params, (err, data) => {
          if (err) j(err)
          else {
            const { CiphertextBlob } = data

            s(CiphertextBlob)
          }
        })
      })
    },
    smsSignin () {
      return new Promise((resolve, reject) => {
        window.confirmationResult
          .confirm(this.validatedCode)
          .then(result => {
            // User signed in successfully.
            var user = result.user
            resolve(user)
          })
          .catch(error => {
            this.isPhoneVerificationCodeError = true
            reject(error)
            // User couldn't sign in (bad verification code?)
            // ...
          })
      })
    },
    kmsDecrypt (params) {
      return new Promise((resolve, reject) => {
        const kmsClient = new KMS() // kmsTool
        kmsClient.decrypt(params, (err, data) => {
          if (err) reject(err)
          else {
            const { Plaintext } = data
            const token = String.fromCharCode(...Plaintext)
            resolve(token)
          }
        })
      })
    },
    getUdnToken (params) {
      return new Promise((resolve, reject) => {
        var lambda = new Lambda()
        lambda.invoke(params, function (err, data) {
          // console.log(data)
          this.data = data
          if (err) reject(err)
          // an error occurred
          else {
            var res = data.Payload.replace(/"/g, '')

            if (res == 'err') reject(new Error('帳號密碼錯誤'))
            resolve(res)
          }
        })
      })
    },
    async udnAccountValidation () {
      if (!this.emailValid || this.udnAccount.pwd.lenght < 4) return

      try {
        // $(".closeBtn").attr("disabled", true);
        this.validated = 1
        //  console.log(this.udnAccount);
        // let account = { email: "udn.device@gmail.com", pwd: "Mobile168" };
        const params = {
          KeyId: this.KeyId,
          Plaintext: JSON.stringify(this.udnAccount)
        }
        // 1.加密帳號密碼
        const res = await this.kmsEncrypt(params)

        // 2.轉 payload data to base 64
        var b64encoded = btoa(String.fromCharCode.apply(null, res))
        // console.log(b64encoded);
        const payload = {
          data: b64encoded
        }
        const udnParams = {
          FunctionName: process.env.LAMBDA_Create_Custom,
          Payload: JSON.stringify(payload)
        }
        // console.log(udnParams.FunctionName)

        // 3.取得 UDN Token
        const udnToken = await this.getUdnToken(udnParams)
        // console.log(udnToken)

        // 4.轉 payload data to base 64
        const KmsParams = {
          // eslint-disable-next-line node/no-deprecated-api
          CiphertextBlob: Buffer(this.base64ToArrayBuffer(udnToken))
        }

        // 5.解密 UDN Token
        const kmsUDNToken = await this.kmsDecrypt(KmsParams)

        // 6.取得 firebase Token
        const user = await this.firebaseLoginWith(kmsUDNToken, 'udn')
        this.getUdnUserFromFirebaseUser(user)
      } catch (err) {
        this.isUdnLoginError = true
        // console.log(err);
        this.validated = 0
      }
    },
    firebaseLoginWith (params, type) {
      return new Promise((resolve, reject) => {
        switch (type) {
          case 'udn':
            firebase
              .auth()
              .signInWithCustomToken(params)
              .then(v => {
                const user = firebase.auth().currentUser
                resolve(user)
              })
              .catch(function (error) {
                // Handle Errors here.
                // var errorCode = error.code
                var errorMessage = error.message
                reject(errorMessage)
              })

            break
          case 'phone':
            // window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
            //   "sign-in-button"
            // );
            window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
              'sign-in-button',
              {
                size: 'invisible'
                // callback: function (response) {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                // alert("onSignInSubmit");
                // onSignInSubmit();
                // }
              }
            )
            firebase.auth().settings.appVerificationDisabledForTesting = true
            var appVerifier = window.recaptchaVerifier
            // eslint-disable-next-line no-case-declarations
            const useNumber = this.CountryCode + this.phoneNumber
            firebase
              .auth()
              .signInWithPhoneNumber(useNumber, appVerifier)
              .then((confirmationResult) => {
                this.countDownFlag = true
                this.end = new Date().getTime() + 60000
                window.confirmationResult = confirmationResult
                this.isPhoneLoginSuccess = true
              })
              .catch(() => {
                window.recaptchaVerifier.render().then(widgetId => {
                  grecaptcha.reset(widgetId)
                })
              })

            break
          case 'fb':
          case 'google':
          case 'apple':
            firebase
              .auth()
              .signInWithPopup(params)
              .then(result => {
                const user = result.user
                resolve(user)
              })
              .catch(error => {
                console.log('signInWithPopup-error')
                // eslint-disable-next-line no-unused-vars
                var errorMessage = error.message
                reject(error)
              })

            break
          default:
            reject(new Error(`type error : ${type}`))
            break
        }
      })
    },
    async getUserDataInfoFromPhone () {
      const user = await this.smsSignin()
      this.getUdnUserFromFirebaseUser(user)
    },
    async getUdnUserFromFirebaseUser (user) {
      // let user = await this.smsSignin();
      // 7.Token to uint8Array

      var params = {
        KeyId: this.KeyId,
        // eslint-disable-next-line node/no-deprecated-api
        Plaintext: Buffer(this.toByArray(user.xa))
      }

      // 8.加密帳 firebase Token
      const token = await this.kmsEncrypt(params)
      // 9.轉 firebase Token to base 64
      var credentialToken = btoa(String.fromCharCode.apply(null, token))
      // console.log("log!!:"+credentialToken);

      localStorage.setItem('credentialToken', credentialToken)

      // 10.取得 個人加密資料
      const res = await getPersonalData(credentialToken)
      if (res.data) {
        const tempData = res.data.data
        // 11.轉 個人加密資料 to base 64
        const params = {
          CiphertextBlob: this.base64ToArrayBuffer(tempData)
        }
        // 12.解密 個人加密資料
        const tempUserData = await this.kmsDecrypt(params)
        localStorage.setItem('user-info', tempUserData)
        const userInfo = JSON.parse(tempUserData)
        this.validated = 0
        if (userInfo.avatar == null) { userInfo.avatar = '@/assets/images/globalMember_icon.png' }

        this.$store.commit('changeUserInfo', userInfo)

        $('.login').fadeOut()
        $('.signForm').fadeOut()
        $('body, .bodyWrapper').removeClass('overflowhidden')
        // console.log(this.$route.name);
        // if(this.$route.name === 'ECoupon') {
        //     // let couponID = Cookies.get("coupon");
        //     this.reload();
        // }
        if (this.$store.state.savePath == '') {
          this.$store.state.savePath = '/index'
        }
        this.$router.push({ path: this.$store.state.savePath, params: { } })
          .catch(err => { console.log(err) })
        this.$store.commit('savePath', '/index')
      }
    },

    toByArray (str) {
      // String to ByArray
      var utf8 = []
      for (var i = 0; i < str.length; i++) {
        var charcode = str.charCodeAt(i)
        if (charcode < 0x80) utf8.push(charcode)
        else if (charcode < 0x800) {
          utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f))
        } else if (charcode < 0xd800 || charcode >= 0xe000) {
          utf8.push(
            0xe0 | (charcode >> 12),
            0x80 | ((charcode >> 6) & 0x3f),
            0x80 | (charcode & 0x3f)
          )
        } else {
          // surrogate pair
          i++
          charcode =
            0x10000 +
            (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff))
          utf8.push(
            0xf0 | (charcode >> 18),
            0x80 | ((charcode >> 12) & 0x3f),
            0x80 | ((charcode >> 6) & 0x3f),
            0x80 | (charcode & 0x3f)
          )
        }
      }
      return utf8
    },
    base64ToArrayBuffer (base64) {
      // eslint-disable-next-line camelcase
      var binary_string = window.atob(base64)
      var len = binary_string.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i)
      }
      return bytes.buffer
    },
    async socialMediaLoginTest (type) {
      // const kmsClient = new KMS() // kmsTool
      let provider
      switch (type) {
        case 'fb':
          provider = new firebase.auth.FacebookAuthProvider()
          break
        case 'google':
          provider = new firebase.auth.GoogleAuthProvider()
          break
        case 'apple':
          provider = new firebase.auth.OAuthProvider('apple.com')
          break
        default:
          return
      }

      const user = await this.firebaseLoginWith(provider, type)
      this.getUdnUserFromFirebaseUser(user)
    },
    stopPoup (e) {
      e.stopPropagation()
    }
  },
  beforeDestroy () {
    document.querySelector('body').removeEventListener('click', this.closeSearch)
  },
  beforeRouteLeave (to, from, next) {
    this.$modalHelper.beforeClose()
    next()
  }
}
</script>

<style lang="scss" scoped>
.search_icon {
  position: relative;
  width: 36px;
  height: 36px;
  display: block;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-size: 0;
  background: none;
  outline: none;
  border: none;
}
.search_group {
  position: relative;
  // z-index: 5;
}
.search_bar {
  position: fixed;
  top: 0px;
  left: 0px;
  padding: 15px;
  z-index: 5;
  width: 100%;
  height: auto;
  transition: all 0.3s ease-in-out;
  transform: translate(0px, -100%) scale(1, 0);
  opacity: 0;
  &.open {
    transform: translate(0px, 0px) scale(1, 1);
    opacity: 1;
  }
  &::after {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    content: "";
    display: block;
    background-color: rgb(255, 255, 255);
  }
  .search_bar_icon {
    z-index: 3;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 25px;
  }
  .search_input {
    position: relative;
    z-index: 1;
    width: calc(100% - 60px);
    color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.05);
    font-size: 1.6rem;
    font-weight: 300;
    border: 0px;
    margin: 0px auto;
    padding: 11px 13px 11px 45px;
    border-radius: 8px;
    outline: none;
  }
  .search_btn {
    position: relative;
    z-index: 1;
    margin-left: 4px;
    width: 50px;
    height: 44px;
    font-size: 1.4rem;
    border-radius: 6px;
    outline: none;
    border: none;
    background: #176E8D;
    box-shadow: 0px 4px 6px -3px rgba(7,102,113,.37);
    &:active {
      background: #176E8D;
    }
  }
  .search_btn_icon {
    position: relative;
    z-index: 3;
    cursor: pointer;
    margin-left: 16px;
  }
  .search_clear_icon {
    position: absolute;
    z-index: 1;
    right: 89px;
    top: 50%;
    transform: translateY(-50%);
    line-height: 16px;
  }

}
.overlay {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.65);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  content: "";
  z-index: -1;
}
@media screen and (min-width: 768px) {
  .search_bar {
    position: absolute;
    left: -229px;
    top: 40px;
    width: 330px;
  }
  .search_bar {
    &::after {
      border-radius: 12px;
      box-shadow: 0px 0px 16px rgba(0,0,0,.16);
    }
    .search_btn_icon {
      display: none;
    }
    .search_clear_icon {
      display: none;
    }
  }
  .overlay {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .search_bar .search_btn {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/subViews/Header.vue